import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import type { Role } from '@/types'

interface ProtectedRouteProps {
  children:      React.ReactNode
  allowedRoles?: Role[]
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
}) => {
  const location          = useLocation()
  const { isAuthenticated, user } = useAuthStore()

  // Not logged in → redirect to login, preserve intended path
  if (!isAuthenticated) {
    return <Navigate to="/giris" state={{ from: location }} replace />
  }

  // Role-based access control
  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/yetkisiz" replace />
  }

  return <>{children}</>
}
